import React, { useEffect, useMemo } from 'react'
import { useForm } from 'react-hook-form'
import Input from 'components/Form/Input'
import Textarea from 'components/Form/Textarea'
import { ButtonFull } from 'components/Form/Button'
import { FormattedMessage, useIntl } from 'react-intl'
import * as yup from 'yup'
import {
	useYupValidationResolver,
	SS,
	getShopPropertiesName,
	parseTokenData,
} from 'utils/common'
import { ReclamationContactFormElem } from './style'
import { sendContactMessage } from './thunk'
import { useDispatch, useSelector } from 'react-redux'

const ReclamationContactForm = ({ item }) => {
	const intl = useIntl()
	const { wasContactMessageDelivered } = useSelector(
		({ reclamationForm }) => reclamationForm
	)
	const dispatch = useDispatch()
	const validationSchema = useMemo(
		() =>
			yup.object().shape({
				email: yup
					.string()
					.email('Invalid email address')
					.required('Required')
					.trim(),
				phone: yup.string().required('Required').trim(),
				comment: yup.string().required('Required').trim(),
			}),
		[]
	)
	const sendAction = (data) => {
		let { email, phone, comment } = data
		let { orderExternalId, orderItemExternalId, shopId } = item

		dispatch(
			sendContactMessage({
				customerComment: comment,
				customerEmail: email,
				customerPhone: phone,
				language: SS.get('language') || 'en',
				orderExternalId: orderExternalId,
				orderExternalSequentialId: null,
				orderItemExternalId: orderItemExternalId,
				shopId: shopId,
			})
		)
	}
	const token = SS.get('token')
	/**
	 * getContactProp {Function}
	 * @description - functiona to get proper contact data for contact form field
	 * @return {String}
	 * */
	const getContactProp = (token, type) => {
		if (token && token[type]) {
			return token[type]
		} else {
			try {
				let parsedData = parseTokenData(token.token)
				let { customer = {} } = parsedData
				return customer[type] ? customer[type] : ''
			} catch (error) {
				console.error(error, 'getContactProp')
			}
		}
	}
	const currentEmail = getContactProp(token, 'email') //props ? props['email'] : ''
	const currentTel = getContactProp(token, 'phone') //props ? props['phone'] : ''

	const { register, handleSubmit, errors } = useForm({
		resolver: useYupValidationResolver(validationSchema),
		defaultValues: {
			email: currentEmail,
			phone: currentTel,
			comment: '',
		},
	})

	useEffect(() => {
		let textArea = document.getElementById('comment')
		if (textArea) {
			textArea.focus()
		}
	}, [])

	return (
		<ReclamationContactFormElem onSubmit={handleSubmit(sendAction)}>
			{wasContactMessageDelivered ? (
				<FormattedMessage
					id='reclamation.contact.us.result.success.text'
					defaultMessage='Your message has been sent, {shopName} will get back to you shortly.'
					values={{
						shopName: getShopPropertiesName() || item?.shopId,
					}}
				/>
			) : (
				<>
					{/*<ReclamationContactFormSubTitle>
						Can't fin the answer you are looking for? Then send a
						message.
					</ReclamationContactFormSubTitle>*/}
					<Input
						type='email'
						name='email'
						placeholder={intl.formatMessage({
							id: 'reclamation.contact.us.dialog.input.email',
							defaultMessage: 'Enter your e-mail',
						})}
						register={register}
						error={errors.email}
						className='mb-3'
					/>
					<Input
						type='tel'
						name='phone'
						placeholder={intl.formatMessage({
							id: 'reclamation.contact.us.dialog.input.phone',
							defaultMessage: 'Enter your phone number',
						})}
						register={register}
						error={errors.phone}
						className='mb-3'
					/>
					<Textarea
						name='comment'
						id='comment'
						register={register}
						error={errors.comment}
						placeholder={intl.formatMessage({
							id: 'reclamation.contact.us.dialog.input.message',
							defaultMessage: 'Write your message here...',
						})}
					></Textarea>
					<ButtonFull dark w100>
						<FormattedMessage
							id='reclamation.contact.us.dialog.send.button'
							defaultMessage='Send'
						/>
					</ButtonFull>
				</>
			)}
		</ReclamationContactFormElem>
	)
}

export default ReclamationContactForm
